import React, { useEffect, useState } from 'react';
import { getFirestore, collection, query, where, onSnapshot } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { Link } from 'react-router-dom';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const db = getFirestore();

export default function NewsPage() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    let q;
    if (filter === 'all') {
      q = query(collection(db, 'news'), where('is_active', '==', true));
    } else {
      q = query(collection(db, 'news'), where('is_active', '==', true), where('category', '==', filter));
    }
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const newsList = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .sort((a, b) => (b.published_at?.seconds || 0) - (a.published_at?.seconds || 0));
      setNews(newsList);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [filter]);

  const getCategoryName = (category) => {
    switch(category) {
      case 'analysis': return 'تحليل فني';
      case 'market_news': return 'أخبار السوق';
      case 'tutorial': return 'شروحات';
      default: return 'عام';
    }
  };

  const getCategoryColor = (category) => {
    switch(category) {
      case 'analysis': return '#dcfce7';
      case 'market_news': return '#dbeafe';
      default: return '#fef3c7';
    }
  };

  const getCategoryTextColor = (category) => {
    switch(category) {
      case 'analysis': return '#166534';
      case 'market_news': return '#1d4ed8';
      default: return '#92400e';
    }
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading news...</div>;
  }

  return (
    <div style={{ padding: '20px', direction: 'ltr', fontFamily: 'Arial' }}>
      <h1 style={{ color: '#1e40af', textAlign: 'center', marginBottom: '24px' }}>
        📰 أخبار وتحليلات TradeAH
      </h1>
      
      {/* فلاتر الفئات */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        gap: '12px',
        marginBottom: '24px',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={() => setFilter('all')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'all' ? '#1e40af' : '#e2e8f0',
            color: filter === 'all' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          الكل
        </button>
        <button
          onClick={() => setFilter('analysis')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'analysis' ? '#1e40af' : '#e2e8f0',
            color: filter === 'analysis' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          التحليلات
        </button>
        <button
          onClick={() => setFilter('market_news')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'market_news' ? '#1e40af' : '#e2e8f0',
            color: filter === 'market_news' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          أخبار السوق
        </button>
        <button
          onClick={() => setFilter('tutorial')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'tutorial' ? '#1e40af' : '#e2e8f0',
            color: filter === 'tutorial' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          الشروحات
        </button>
      </div>

      {/* عرض الأخبار */}
      {news.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px', color: '#cbd5e1' }}>📰</div>
          <p>لا توجد أخبار حالياً</p>
        </div>
      ) : (
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', 
          gap: '24px'
        }}>
          {news.map(item => (
            <div 
              key={item.id}
              style={{ 
                backgroundColor: 'white',
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                transition: 'transform 0.2s, box-shadow 0.2s',
                cursor: 'pointer'
              }}
              onClick={() => window.open(`/news/${item.id}`, '_blank')}
            >
              {/* صورة الخبر */}
              {item.image_url ? (
                <div style={{ height: '200px', overflow: 'hidden' }}>
                  <img
                    src={item.image_url}
                    alt={item.title}
                    style={{ 
                      width: '100%', 
                      height: '100%', 
                      objectFit: 'cover' 
                    }}
                  />
                </div>
              ) : (
                <div style={{ 
                  height: '200px', 
                  backgroundColor: '#f1f5f9',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: '#64748b'
                }}>
                  لا توجد صورة
                </div>
              )}
              
              {/* تفاصيل الخبر */}
              <div style={{ padding: '16px' }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  marginBottom: '8px'
                }}>
                  <span style={{ 
                    backgroundColor: getCategoryColor(item.category),
                    color: getCategoryTextColor(item.category),
                    padding: '4px 8px',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>
                    {getCategoryName(item.category)}
                  </span>
                  <span style={{ 
                    fontSize: '12px', 
                    color: '#64748b' 
                  }}>
                    {item.author}
                  </span>
                </div>
                
                <h3 style={{ 
                  margin: '0 0 12px 0', 
                  color: '#0f172a', 
                  fontSize: '18px',
                  fontWeight: 'bold',
                  lineHeight: '1.4'
                }}>
                  {item.title}
                </h3>
                
                <p style={{ 
                  margin: 0, 
                  color: '#64748b', 
                  fontSize: '14px',
                  lineHeight: '1.6',
                  height: '60px',
                  overflow: 'hidden'
                }}>
                  {item.summary}
                </p>
                
                <div style={{ 
                  marginTop: '12px', 
                  fontSize: '12px', 
                  color: '#64748b',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <span>
                    {item.published_at?.toDate?.().toLocaleDateString('ar-EG') || 'غير معروف'}
                  </span>
                  <span style={{ 
                    color: '#1e40af', 
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}>
                    اقرأ المزيد →
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}